import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizEntryBankEdit;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@instructure/ui-grid';
import { View } from '@instructure/ui-view';
import { RadioInput, RadioInputGroup } from '@instructure/ui-radio-input';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import NumberInput from '@instructure/quiz-number-input';
import { Text } from '@instructure/ui-text';
import { Alert } from '@instructure/ui-alerts';
import { jsx } from '@instructure/emotion';
import EntrySave from '../../../../../../common/components/resources/entry/EntrySave';
import BankSelection from '../../../../../../common/components/resources/BankSelection/presenter';
import QuizEntry from '../../../../../../common/records/QuizEntry';
import Bank from '../../../../../../common/records/Bank';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
export var QuizEntryBankEdit = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizEntryBankEdit = /*#__PURE__*/function (_Component) {
  function QuizEntryBankEdit() {
    var _this2;
    _classCallCheck(this, QuizEntryBankEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizEntryBankEdit, [].concat(args));
    _defineProperty(_this2, "state", {
      rawPointsPossible: _this2.props.pointsPossible,
      normalizedPointsPossible: _this2.props.pointsPossible
    });
    _defineProperty(_this2, "clearChanges", function () {
      _this2.props.clearModifications('quizEntries', _this2.props.quizEntry.id);
    });
    _defineProperty(_this2, "handlePointsChange", function (event, points, normalizedPointsString) {
      var normalizedPoints = Number(normalizedPointsString);
      _this2.setState({
        rawPointsPossible: points,
        normalizedPointsPossible: normalizedPoints
      });
      _this2.props.changeQuizEntryPoints(_this2.props.quizEntry.id, normalizedPoints);
    });
    _defineProperty(_this2, "handlePointsBlur", function () {
      _this2.setState({
        rawPointsPossible: _this2.props.pointsPossible || '0'
      });
    });
    _defineProperty(_this2, "onPropertiesChange", function (properties) {
      _this2.props.changeQuizEntryProperties(_this2.props.quizEntry.id, properties);
    });
    _defineProperty(_this2, "onBankSelection", function (event, option) {
      _this2.props.addBank(option.id, option);
      _this2.props.changeQuizEntryEntry(_this2.props.quizEntry.id, option.id);
    });
    _defineProperty(_this2, "handleQuestionChange", function (event, selection) {
      _this2.onPropertiesChange({
        sampleNum: _this2.props.sampleNum,
        selection: selection
      });
    });
    _defineProperty(_this2, "handleSampleNumChange", function (event, sampleNum, normalizedSampleNum) {
      _this2.onPropertiesChange({
        sampleNum: normalizedSampleNum || '0',
        selection: _this2.props.questionSelection
      });
    });
    _defineProperty(_this2, "sampleNumErrors", function () {
      return _this2.props.workingQuizEntry.sampleNumErrors();
    });
    _defineProperty(_this2, "pointsPossibleErrors", function () {
      return _this2.props.workingQuizEntry.pointsPossibleErrors();
    });
    _defineProperty(_this2, "submitHandler", function () {
      var properties = {};
      if (_this2.props.questionSelection === 'all') {
        properties.sampleNum = null;
      } else {
        properties.sampleNum = _this2.props.sampleNum;
      }
      _this2.props.updateQuizEntry(_this2.props.quizId, _this2.props.quizEntry.id, {
        properties: properties,
        pointsPossible: _this2.state.normalizedPointsPossible,
        entryId: _this2.props.workingBank.id
      });
      _this2.props.clearModifications();
    });
    _defineProperty(_this2, "renderPointsPossibleRow", function () {
      return jsx(Grid.Row, null, jsx(Grid.Col, {
        width: 3
      }, jsx(Text, {
        color: "primary"
      }, t('Points per question'))), jsx(Grid.Col, {
        width: 9
      }, jsx(NumberInput, {
        renderLabel: jsx(ScreenReaderContent, null, t('Points per question')),
        onChange: _this2.handlePointsChange,
        onBlur: _this2.handlePointsBlur,
        value: _this2.state.rawPointsPossible,
        width: "5rem",
        display: "inline-block",
        messages: _this2.pointsPossibleErrors()
      })));
    });
    return _this2;
  }
  _inherits(QuizEntryBankEdit, _Component);
  return _createClass(QuizEntryBankEdit, [{
    key: "renderQuestionSelectRadioGroup",
    value: function renderQuestionSelectRadioGroup() {
      return jsx(RadioInputGroup, {
        name: "questionSelect",
        description: t('Question selection'),
        defaultValue: this.props.questionSelection,
        onChange: this.handleQuestionChange
      }, jsx(RadioInput, {
        key: "all",
        value: "all",
        label: t('Use all questions')
      }), jsx(RadioInput, {
        key: "rand",
        value: "rand",
        label: t('Randomly select questions')
      }));
    }
  }, {
    key: "renderRandomQuestionSelectionRow",
    value: function renderRandomQuestionSelectionRow() {
      if (this.props.questionSelection === 'all') {
        return;
      }
      return jsx(Grid.Row, null, jsx(Grid.Col, {
        width: 3
      }, jsx(Text, {
        color: "primary"
      }, t('Number of questions'))), jsx(Grid.Col, {
        width: 9
      }, jsx(NumberInput, {
        renderLabel: jsx(ScreenReaderContent, null, t('Number of questions')),
        onChange: this.handleSampleNumChange,
        value: this.props.sampleNum,
        min: 1,
        width: "5rem",
        display: "inline-block",
        messages: this.sampleNumErrors()
      })));
    }
  }, {
    key: "renderQuestionNumberInputs",
    value: function renderQuestionNumberInputs() {
      return jsx(Grid, {
        vAlign: "middle",
        rowSpacing: "small"
      }, this.renderRandomQuestionSelectionRow(), this.renderPointsPossibleRow());
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return jsx("div", {
        css: this.props.styles.quizEntryBankText
      }, jsx(BankSelection, {
        label: t('Select the source bank'),
        selectedBank: this.props.workingBank,
        onBankSelection: this.onBankSelection
      }), jsx("br", null), this.renderQuestionSelectRadioGroup(), jsx("br", null), this.renderQuestionNumberInputs());
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      if (this.props.workingBank.archived) {
        return jsx(Alert, {
          variant: "error"
        }, jsx(Text, {
          color: "primary"
        }, t('Item bank no longer exists!')));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.quizEntryBankEdit
      }, this.renderErrors(), this.renderContent(), jsx("div", {
        css: this.props.styles.borderLine
      }), jsx(View, {
        textAlign: "end"
      }, jsx(EntrySave, {
        clearChanges: this.clearChanges,
        displayPosition: this.props.displayPosition,
        disableSubmit: !this.props.workingQuizEntry.isValid(),
        entry: this.props.workingBank,
        guid: this.props.guid,
        submitHandler: this.submitHandler
      })));
    }
  }]);
}(Component), _defineProperty(_QuizEntryBankEdit, "displayName", 'QuizEntryBankEdit'), _defineProperty(_QuizEntryBankEdit, "componentId", "Quizzes".concat(_QuizEntryBankEdit.displayName)), _defineProperty(_QuizEntryBankEdit, "propTypes", {
  changeQuizEntryPoints: PropTypes.func.isRequired,
  changeQuizEntryProperties: PropTypes.func.isRequired,
  changeQuizEntryEntry: PropTypes.func.isRequired,
  clearModifications: PropTypes.func.isRequired,
  displayPosition: PropTypes.number.isRequired,
  guid: PropTypes.string.isRequired,
  // used for makeEditable
  pointsPossible: PropTypes.number.isRequired,
  questionSelection: PropTypes.string.isRequired,
  quizEntry: PropTypes.instanceOf(QuizEntry).isRequired,
  quizId: PropTypes.string.isRequired,
  sampleNum: PropTypes.string,
  updateQuizEntry: PropTypes.func.isRequired,
  workingBank: PropTypes.instanceOf(Bank).isRequired,
  workingQuizEntry: PropTypes.instanceOf(QuizEntry).isRequired,
  styles: PropTypes.object,
  addBank: PropTypes.func.isRequired
}), _defineProperty(_QuizEntryBankEdit, "defaultProps", {
  sampleNum: void 0
}), _QuizEntryBankEdit)) || _class);
export default QuizEntryBankEdit;